<div class="form-field-label">
  <span>{{ label }}</span>
  @if (info) {
    <span
      class="info-icon ml-2 dashboard-tooltip"
      matTooltipClass="dig-tooltip"
      #tooltip="matTooltip"
      (click)="tooltip.toggle()"
      [matTooltip]="info"
    >
      <span inlineSVG="/icons/icon-info-circle-v2.svg"></span>
    </span>
  }
</div>
<div class="field-row">
  <mat-form-field class="form-field" [floatLabel]="'auto'">
    <input
      matInput
      type="text"
      placeholder="GTM-XXXXXXX"
      maxlength="32"
      autocapitalize="characters"
      spellcheck="false"
      [formControl]="$any(control)"
      (blur)="normalizeOnBlur()"
    />
  </mat-form-field>
  <button class="btn btn-dark-theme btn-grey btn-sm cta-btn snippet-btn" type="button" (click)="openSnippetDialog()">
    {{ 'gtm_snippet.open' | transloco }}
  </button>
</div>
@if (showsError) {
  <p class="field-error">{{ 'form.error.invalid_gtm_container_id' | transloco }}</p>
}
@if (hint && !showsError) {
  <p class="field-hint">{{ hint }}</p>
}
